import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { StyleSheet, Text, View, ImageBackground } from 'react-native';
import { WiCloudy } from "weather-icons-react";

import Sidebar from './sidebar';
import MainWeather from './main_weather';
import Loader from './loader';
import { useSelector } from 'react-redux';
export default function ClearWeather() {
  var w_data = useSelector(state => state.weather);
  const [lat, setLat] = React.useState([]);
  const [long, setLong] = React.useState([]);
  const REACT_APP_API_URL = 'https://api.openweathermap.org/data/2.5';
  const REACT_APP_API_KEY = '5d361ddf57410aae46781a0990a8d7f6';
  const REACT_APP_ICON_URL = 'https://openweathermap.org/img/w';
  const [data, setData] = React.useState([]);
  const [data_loaded, set_data_loaded] = React.useState(false);
  const [runned, set_runned] = React.useState(false);

  return (

    <ImageBackground source={{ uri: "https://firebasestorage.googleapis.com/v0/b/imagehosting-cb259.appspot.com/o/else_weather.png?alt=media&token=11ba840d-2c42-45f2-97f2-d1b0e2a446a1" }} style={{ width: "100%", height: "100%", resizeMode: "contain" }}>
      {(typeof w_data.main != 'undefined') ? (
        <ImageBackground source={{ uri: "https://firebasestorage.googleapis.com/v0/b/imagehosting-cb259.appspot.com/o/else_weather.png?alt=media&token=11ba840d-2c42-45f2-97f2-d1b0e2a446a1" }} style={{ width: "100%", height: "100%", resizeMode: "contain" }}>
          <MainWeather />
          <Sidebar />

        </ImageBackground>

      ) : (
        <Loader />
      )
      }

    </ImageBackground >
  )
}



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
